import { FONTS, COLORS } from '../../../../constants';

// eslint-disable-next-line no-unused-vars
const styles = theme => {
  // take mobile-first approach to do the styling

  const minXs = theme.breakpoints.up('xs');
  const minSm = theme.breakpoints.up('sm');
  const minMd = theme.breakpoints.up('md');
  const minLg = theme.breakpoints.up('lg');

  return {
    serviceAreasCardContent: {
      padding: '0px',
      paddingBottom: '0px !important',
    },
    buttonActive: {
      backgroundColor: '#4d4d4d',
      color: '#ffffff',
    },
    locationImage: {
      maxWidth: '100%',
      maxHeight: '489px',
      margin: 'auto',
    },
    cardHeaderRoot: {
      backgroundColor: COLORS.GREY_DARK,
    },
    cardHeaderTitle: {
      color: COLORS.WHITE,
      textAlign: 'center',
      fontSize: '1.25rem',
      fontWeight: 600,
    },
    stateSelectContain: {
      display: 'flex',
    },
    stateSelect: {
      flex: '1',
    },
    serviceAreaContain: {
      display: 'flex',
      flexDirection: 'column-reverse',
      [minMd]: {
        flexDirection: 'row',
      },
    },
    serviceAreaForm: {
      flex: '1',
      [minXs]: {
        padding: '10px',
      },
      [minSm]: {
        padding: '30px',
      },
    },
    serviceAreaMapContain: {
      display: 'flex',
      [minXs]: {
        flex: '1',
        // maxHeight: '264px',
      },
      [minLg]: {
        flex: '2',
        maxHeight: '100%',
      },
    },
    serviceAreaMap: {
      [minMd]: {
        height: '486px',
      },
      width: '100%',
      height: '264px',
    },
    serviceAreaButtonsContain: {
      display: 'flex',
      paddingBottom: '10px',
    },
    serviceAreaButtons: {
      '&:hover': {
        border: 'solid 2px #4d4d4d',
        textTransform: 'none',
        backgroundColor: '#4d4d4d',
        color: '#ffffff',
      },
      border: 'solid 2px #4d4d4d',
      textTransform: 'none',
    },
    serviceAreaButtonsLeft: {
      flex: '1',
      borderBottomRightRadius: '0px',
      borderTopRightRadius: '0px',
    },
    serviceAreaButtonsCenter: {
      '&:hover': {
        borderRight: '1px',
        borderLeft: '1px',
      },
      flex: '1',
      borderRadius: '0px',
      borderRight: '1px',
      borderLeft: '1px',
    },
    serviceAreaButtonsRight: {
      flex: '1',
      borderBottomLeftRadius: '0px',
      borderTopLeftRadius: '0px',
    },
    formRow: {
      width: '100%',
      [minXs]: {
        display: 'flex',
        justifyContent: 'space-between',
      },
      '&:first-child': {
        marginTop: -20,
        [minMd]: {
          marginTop: -30,
        },
      },
    },
    formGroup: {
      width: '100%',
      marginTop: 20,
      [minMd]: {
        marginTop: 30,
      },
    },
    halfFormGroup: {
      width: '100%',
      [minXs]: {
        width: '48%',
      },
    },
    serviceAreaCoord: {
      '& label': {
        display: 'none',
      },
    },
    errMsg: {
      color: COLORS.RED,
      fontFamily: FONTS.PRIMARY,
      fontWeight: 300,
      fontSize: '0.875rem',
    },
  };
};

export default styles;
